export default __webpack_public_path__ + "static/media/mix2infibre.83e561be.jpg";